export const FETCH_PAGE_PENDING = 'FETCH_PAGE_PENDING';
export const FETCH_PAGE_FULFILLED = 'FETCH_PAGE_FULFILLED';
export const FETCH_PAGE_FAILED = 'FETCH_PAGE_FAILED';
export const FETCH_PAGE_SETTINGS_PENDING = 'FETCH_PAGE_SETTINGS_PENDING';
export const FETCH_PAGE_SETTINGS_FULFILLED = 'FETCH_PAGE_SETTINGS_FULFILLED';
export const FETCH_PAGE_SETTINGS_FAILED = 'FETCH_PAGE_SETTINGS_FAILED';
export const SET_INITIAL_DATA_FULFILLED = 'SET_INITIAL_DATA_FULFILLED';
export const TILE_DECORATION_MOUNTED = 'TILE_DECORATION_MOUNTED';
export const ROUTE_LOCATION_UPDATE_FULFILLED = 'ROUTE_LOCATION_UPDATE_FULFILLED';
